
<div>
    <div style="position: relative">
        <div v-if="size" style="position: absolute; bottom: 10px; right: 15px; z-index: 5">
            {{ Math.round(size / 1024) }} KB
        </div>
        <img
            v-if="image"
            :src="image"
            class="image"
        />
    </div>
</div>
